import { Loader2 } from "lucide-react";
import PageShell from "@/components/PageShell";

/**
 * Écran d'attente pendant qu'une route se charge.
 *
 * Chaque page portant son propre en-tête, un repli nu faisait disparaître le
 * site en entier : sur une connexion mobile lente, l'écran restait vide quatre
 * secondes, le temps que le chunk de la page arrive. Le premier artisan inscrit
 * l'a décrit comme « une page qui n'avait aucun rapport avec l'enregistrement
 * d'une montre », et il visait juste — la route n'était pas encore chargée.
 *
 * On réutilise donc PageShell plutôt que d'en redessiner l'en-tête : le
 * visiteur voit le site charger une page, au lieu du néant. Ce n'est l'adresse
 * de rien, d'où `noindex`.
 */
export default function RouteFallback() {
  return (
    <PageShell testId="route-loading" bareTitle noindex>
      <div className="flex items-center justify-center py-32">
        <Loader2 size={28} className="animate-spin text-gold-ink" />
      </div>
    </PageShell>
  );
}
